import React from 'react';

import { Snackbar as SnackbarTecma, useDevice } from '@tecma/ds';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import { applicationStateActions } from 'store/slices/applicationState/slice';

import type { AlertType } from '@tecma/ds/lib/components/Alert/Alert';


import './snackbar.scss';

export type SnackbarProps = {
  open: boolean;
  title?: string;
  description?: string;
  type?: AlertType;
};

const Snackbar: React.FC<SnackbarProps> = ({ open, title, description, type }) => {
  const dispatch = useDispatch();
  const device = useDevice();

  const snackbarClassList = classNames('mh-snackbar', {
    [`${device.type}`]: device.type,
  });

  const closeSnackbar = () => {
    dispatch(applicationStateActions.setSnackbar(undefined));
  };
  return (
    <SnackbarTecma
      className={snackbarClassList}
      open={open}
      handleClose={closeSnackbar}
      title={title}
      description={description}
      type={type}
      anchorOrigin={{
        vertical: 'top',
        horizontal: device.type === 'mobile' ? 'center' : 'right',
      }}
    />
  );
};

export default Snackbar;
